import { clearInvitationAcceptanceSession } from '@modules/invitation/utils/clearInvitationAcceptanceSession'
import { hasRecentInvitationAcceptanceInSession } from '@modules/invitation/utils/hasRecentInvitationAcceptanceInSession'
import { addProject, getCurrentProject, useProjectsStore } from '@modules/projects'
import { createWorkspace } from '@modules/workspaces'

import { DEFAULT_PROJECT_NAME, DEFAULT_WORKSPACE_NAME } from '../onboarding.const'

import { finalizeOnboardingShellState } from './finalizeOnboardingShellState'
import { syncProjectAfterCreate } from './syncProjectAfterCreate'
import { waitForWorkspaceInStore } from './waitForWorkspaceInStore'

async function syncExistingWorkspace(workspaceId: string): Promise<void> {
  if (!useProjectsStore.getState().currentProject) {
    await getCurrentProject(workspaceId)
  }

  if (!useProjectsStore.getState().currentProject) {
    const createdProjectId = await addProject({
      name: DEFAULT_PROJECT_NAME,
      workspaceId,
      description: 'Our first project',
    })
    await syncProjectAfterCreate(workspaceId, createdProjectId)
  }

  await finalizeOnboardingShellState({ preferredWorkspaceId: workspaceId })
}

export async function runOnboardingWorkspaceSetup(): Promise<void> {
  const fromInvitation = hasRecentInvitationAcceptanceInSession()
  const workspace = fromInvitation ? await waitForWorkspaceInStore(5, 1000) : await waitForWorkspaceInStore(1, 0)

  if (fromInvitation) {
    clearInvitationAcceptanceSession()
  }

  if (workspace) {
    await syncExistingWorkspace(workspace.workspaceId)
    return
  }

  if (fromInvitation) {
    throw new Error('Workspace not available after accepting invitation')
  }

  console.warn('[Onboarding] creating default workspace', {
    defaultName: DEFAULT_WORKSPACE_NAME,
  })

  const createdWorkspaceKey = await createWorkspace(DEFAULT_WORKSPACE_NAME)

  if (!createdWorkspaceKey) {
    throw new Error('Failed to create default workspace during onboarding')
  }

  const createdWorkspace = await waitForWorkspaceInStore(5, 1000)
  if (!createdWorkspace) {
    throw new Error('Workspace not available after onboarding create')
  }

  const createdProjectId = await addProject({
    name: DEFAULT_PROJECT_NAME,
    workspaceId: createdWorkspace.workspaceId,
    description: 'Our first project',
  })
  await syncProjectAfterCreate(createdWorkspace.workspaceId, createdProjectId)

  await finalizeOnboardingShellState({
    preferredWorkspaceId: createdWorkspaceKey,
  })
}
